export enum FontDropDownMode {
    fontSize = 'font-size',
    fontFamily = 'font-family'
}
